import { render } from "./Vms.vue?vue&type=template&id=e233a8b8&scoped=true"
import script from "./Vms.vue?vue&type=script&lang=js"
export * from "./Vms.vue?vue&type=script&lang=js"

import "./Vms.vue?vue&type=style&index=0&id=e233a8b8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e233a8b8"]])

export default __exports__